<template lang="pug">
  div
    h1 It's been {{days.served}} days since this dumpster 🔥 of a Presidency began...
    h1 There are {{days.left}} days left. The term is only {{ (days.served / days.term).toFixed(2) * 100 }}% over... 😰
</template>

<script>
export default {
  name: 'days'
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// Days.vue?5fc0bf04